import { render, staticRenderFns } from "./StarRatings.vue?vue&type=template&id=56686296&scoped=true"
import script from "./StarRatings.vue?vue&type=script&lang=js"
export * from "./StarRatings.vue?vue&type=script&lang=js"
import style0 from "./StarRatings.vue?vue&type=style&index=0&id=56686296&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56686296",
  null
  
)

export default component.exports